import { NavigateFunction, Location } from 'react-router-dom';

import { ToggleStateStore } from 'stores/common/ToggleStateStore';

import { RouterStore } from './RouterStore';
import { UserStore } from './UserStore';

type RootStoreInitParams = {
  location: Location;
  navigate: NavigateFunction;
};

export default class RootStore {
  readonly userStore = new UserStore();
  private _routerStore: RouterStore | null = null;
  readonly initialized = new ToggleStateStore();

  get routerStore(): RouterStore | null {
    return this._routerStore;
  }

  async init(params: RootStoreInitParams): Promise<void> {
    await this.userStore.loadUser();
    this._routerStore = new RouterStore({
      navigate: params.navigate,
      location: params.location,
    });
    this.initialized.open();
  }
}
